import Accounts from './accountsActions';
import S3 from './s3Actions';
import Costs from './costsActions';
import Reports from './reportsActions';
import Resources from './resourcesActions';
import Map from './mapActions';
import Tags from './tagsActions';

export default {
  Accounts,
	S3,
  Costs,
  Reports,
  Resources,
  Map,
  Tags
};



// WEBPACK FOOTER //
// ./src/actions/aws/index.js